import CommonService from "../../../services/commonService";

const classes = [
    // kennybus 
    { name: 'kennybuslight', className: 'cera_Pro_light' },
    { name: 'kennybusmedium', className: 'cera_Pro_medium' },
    { name: 'kennybusbold', className: 'cera_Pro_Bold' },

    //SaoPaulo 
    { name: 'saopaulosemibold', className: 'poppins-semibold' },
]

const getFonts = (type) => {
    const operator = CommonService.getLocal('op');

    const name = operator && operator.operator_name ? operator.operator_name : ''

    const fontName = `${name}${type}`

    const showFont = classes.find(val => val.name === fontName);
    return showFont && showFont.className ? showFont.className : ''
}

export default getFonts


// WEBPACK FOOTER //
// ./src/features/themes/functions/getFonts.js